import { PropsWithChildren } from "react";

/** Squares off the corners of a row of buttons so they read as one control.
 *
 * The styled-components original also tried to re-round the outer corners, but
 * those rules were written as descendant selectors (`button :first-child`), so
 * they landed on the button's contents rather than the button and never had a
 * visible effect. Only the behavior that was actually rendering is kept here.
 */
export const LegacyButtonGroup: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="flex [&_button]:rounded-none!">{children}</div>;
